
/**
 * @description
 * 로드맵 상세페이지 > 요약
 */

import CourseInfo from './CourseInfo.vue';
import CourseSummaryTitle from './CourseSummaryTitle.vue';
import DetailCourseFavorite from './DetailCourseFavorite.vue';
import TagList from './TagList.vue';

export default {
  name: 'CourseSummary',
  components: { TagList, DetailCourseFavorite, CourseSummaryTitle, CourseInfo },
};
